import { KeyStarIcon } from './KeyStarIcon';

/**
 * author: Haley Halcyon
 * id 7C312A2D-A502-4F06-89D4-0783EADC3B3F
 * name key-star
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/key-star.svg
 * tags
 */
export const KeyFavoriteIcon = KeyStarIcon;
export default KeyFavoriteIcon